(() => {
  if (window.st26NavigationReady) return;
  window.st26NavigationReady = true;
  const mobile = window.matchMedia('(max-width: 1099px)');

  const closeDetails = (details, restoreFocus = false) => {
    if (details.matches('[data-st26-mobile-nav]') && !mobile.matches) return;
    details.open = false;
    details.querySelectorAll('details[open]').forEach((child) => { child.open = false; });
    if (restoreFocus) details.querySelector(':scope > summary')?.focus();
  };

  const footerMobile = matchMedia('(max-width: 749px)');
  footerMobile.addEventListener('change',()=>document.querySelectorAll('.st26-footer__disclosure').forEach(item=>{item.open=!footerMobile.matches;}));
  const initialize = (scope = document) => {
    scope.querySelectorAll('.st26-footer__disclosure').forEach(item=>{if(!item.dataset.ready){item.open=!footerMobile.matches;item.dataset.ready='true';}});
    scope.querySelectorAll('.st26-header details').forEach((details) => {
      if (details.dataset.st26Ready) return;
      details.dataset.st26Ready = 'true';
      if (details.matches('[data-st26-mobile-nav]')) details.open = !mobile.matches;
      const summary = details.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => {
        summary?.setAttribute('aria-expanded', String(details.open));
        if (!details.open) return;
        const header = details.closest('.st26-header');
        header.querySelectorAll('details[open]').forEach((other) => {
          if (other !== details && !other.contains(details) && !details.contains(other)) closeDetails(other);
        });
        if (details.classList.contains('st26-header__popover')) {
          details.querySelector('input:not([type="hidden"]), select, button')?.focus();
        } else if (details.matches('[data-st26-mobile-nav]') && mobile.matches) {
          details.querySelector('.st26-header__nav-panel a, .st26-header__nav-panel summary')?.focus();
        }
      });
    });
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('.st26-header details[open]');
    if (!details) return;
    event.preventDefault();
    event.stopPropagation();
    closeDetails(details, true);
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.st26-header details[open]').forEach((details) => {
      if (!details.contains(event.target)) closeDetails(details);
    });
  });

  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('.st26-header details[open]').forEach((details) => {
      if (!details.contains(event.target)) closeDetails(details);
    });
  });

  mobile.addEventListener('change', () => {
    document.querySelectorAll('.st26-header details[open]').forEach((details) => closeDetails(details));
    document.querySelectorAll('[data-st26-mobile-nav]').forEach((details) => { details.open = !mobile.matches; });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
    const cartLink = event.target.querySelector('.st26-header #cart-icon-bubble');
    // Dawn marks this link when it attaches its click and keyboard handlers.
    // A reused editor section already has them; a replaced section needs them.
    if (cartLink && cartLink.getAttribute('aria-haspopup') !== 'dialog') {
      document.querySelector('cart-drawer')?.setHeaderCartIconAccessibility?.();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();
